import store from '@/store';

export default (to, from, next) => {
    const is_billing_routing_allowed = store.getters.is_app_environment_billing_routing_allowed;

    return {
        allow: is_billing_routing_allowed,
        redirect: { name: 'not-found' },
    }
};
